import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExgDataTableComponent, ExgModalService} from 'exc-controls-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExgFilterComponent} from "../../misc/exg-filter/exg-filter.component";
import {IExcMetaInfo} from "exc-rest-v2/lib/interfaces/IExcMetaInfo";

@Component({
  selector: 'app-modal-co-editor',
  templateUrl: './modal-co-editor.component.html',
  styles: [
  ]
})
export class ModalCoEditorComponent extends ExcTranslation implements OnInit {

  @ViewChild('VCoeUserList', {read: ExgDataTableComponent}) VCoeUserList!: ExgDataTableComponent;

  _data: any = [];
  init = true;

  oeUserList = {
    data: [] as any,
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    isLoading: true
  };

  //config
  config = {
    oeUserList: {
      selectKey: 'oeID',
      state: 1,
      selectedRow: undefined as any,
      searchValue: '',
      uiFilter: [] as any[],
      uiSort: [] as any[],
      ready: () => {
        if (!this.oeUserList.data || this.oeUserList.data.length === 0) {
          this.config.oeUserList.state = 2;
          this.VCoeUserList.selectedRow = -1;
        } else {
          this.config.oeUserList.state = 0;
          this.VCoeUserList.selectedRow = 0;
        }
        this.init = false;
      },
      selectionChanged: (index:number) => {
        this.config.oeUserList.selectedRow = this.oeUserList.data[index];
      },
      pageChanged: (page: number) => {
        if (this.oeUserList.MetaInfo.dataPaging !== undefined) {
          this.oeUserList.MetaInfo.dataPaging.pageNo = page;
        }
        this.config.oeUserList.loadData();
      },
      search: (value: string) => {
        this.config.oeUserList.searchValue = value;
        this.config.oeUserList.pageChanged(1);
      },
      loadData: () => {
        const SELF = this;
        SELF.config.oeUserList.state = 1;
        SELF.oeUserList.isLoading = true;
        SELF.excRestService
          .sget(
            SELF.excRestService.computeUrl('OeR_List_User', {
              fts: this.config?.oeUserList?.searchValue,
            }),
            'userList',
            {MetaInfo: SELF.oeUserList.MetaInfo}
          )
          .subscribe((response) => {
            if (response.success && response.data) {
              SELF.oeUserList.data = response.data
              SELF.oeUserList.paging = response.paging;
            } else {
              SELF.oeUserList.data = [];
              SELF.oeUserList.paging = {
                pagingPage: 0,
                pagingEndRow: 0,
                pagingPageSize: 25,
                pagingTotalPages: 0,
                pagingTotalRows: 0,
                pagingStartRow: 0,
              };
            }
            SELF.config.oeUserList.ready();
            SELF.oeUserList.isLoading = false;
          });
      }
    }
  };

  @Input()
  set data(value: any) {
    if(value){
      this.oeUserList.data = value;
    }
  }

  get data(): any {
    return this.oeUserList;
  }

  constructor(public excRestService: ExcRestService, public modal: ExgModalService, public enumSvc: EnumerationService) {
    super();
    const SELF = this;
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    this.config.oeUserList.loadData();
  }

  clickedSave(): void {
    const SELF = this;
    this.modal.action(this.config.oeUserList.selectedRow);
    SELF.modal.close();
  }

  clickedCancel(): void {
    const SELF = this;
    SELF.modal.close();
  }

}
